import React, { PropTypes } from 'react';
import CookieItpUtils from 'frilans-finans/utils/cookie-itp-utils';
import Modal from 'react-modal';
import moment from 'moment';
import { UserSettingsConstants } from 'frilans-finans';
import Translate from 'react-translate-component';

class AffectedItpOneModal extends React.Component {

  static propTypes = {
    user: PropTypes.object
  }

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };

    this.affectedByITP = this.affectedByITP.bind(this);
    this.shouldRender = this.shouldRender.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  shouldRender () {
    // TODO remove when not needed anymore
    // also remove cookie-itp-utils.js

    const startDate = moment('2022-04-07');
    const endDate = moment('2023-01-01');
    const nowDate = moment();

    let openModal = false;
    if (nowDate.isBetween(startDate, endDate) &&
      !CookieItpUtils.getItpCookie('ff_affected_itp_two') &&
      this.affectedByITP()
    ) {
      openModal = true;
    }

    return openModal;
  }

  affectedByITP () {
    let ssnr = this.props.user.socialSecurityNr;
    if (ssnr === undefined || ssnr === null) {
      return false;
    }

    if (this.props.user.saveITP) {
      return false;
    }

    let thisYear = (new Date()).getFullYear();
    let age = thisYear - (ssnr).substring(0, 4);

    return age >= UserSettingsConstants.itpAgeThresholdLower && age < UserSettingsConstants.itpAgeThresholdUpper;
  }

  onCloseModal () {
    this.setState({
      open: false
    });
    CookieItpUtils.setItpCookie('ff_affected_itp_two');
  }

  render () {
    return this.shouldRender() && this.state.open
      ? (<Modal
        className='modal modal-extra-wide'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.onCloseModal}>
        <div className='modal-content'>
          <button className='close' onClick={this.onCloseModal}></button>
          <h2><Translate content='AFFECTED_ITP_MODAL_TWO_TITLE'/></h2>
          <Translate content='AFFECTED_ITP_MODAL_TWO_BODY' className='pre-wrap' />
          <div className='center'>
            <button className='btn mt35' onClick={this.onCloseModal}><Translate content='CLOSE'/></button>
          </div>
        </div>
      </Modal>)
      : null;
  }
}

export default AffectedItpOneModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/affected-itp-two-modal.js
 **/